export const setGames = (state, { games }) => {
  state.games = games;
};
